import { SET_LOGGEDIN, SET_TOKEN, SET_USER_DETAILS, SET_MENU_ITEMS,
    SET_SELLERCREATION, SET_ACCOUNTTYPE, SET_BUYNOWPRODUCTS, SET_ACCOUNT_DETAILS, 
    SET_REGION, SET_ZODIACFILTER, SET_OCCUPATIONFILTER, SET_FlAWFILTER, SET_STATUSFILTER, 
    SET_COUNT_API, SET_EDUCATIONLIST, SET_FULL_EDUCATIONLIST, SET_ZODIACSIGNS, SET_FLAWS, SET_STATUS, 
    SET_OCCUPATION, SET_ALLSTARS, SET_FULL_OCCUPATIONS, SET_TEDUCATIONS, SET_TFLAWS, SET_TSTATUS, 
    SET_TOCCUPATION, SET_DHISA, SET_INITIAL_LOADING_FILTER, SET_SEARCH_VALUE, SET_MIN_AGE, SET_MAX_AGE, SET_SEARCH_COUNT, SET_TDHISA, 
    SET_FETCH_USER_DETAILS} from "./constants";
import authStore from "./stores";

const authReducers = (state = authStore, action) => {
    switch (action.type) {
        case SET_LOGGEDIN:
            return { ...state, isLoggedIn: action.payload }
        case SET_TOKEN:
            return { ...state, token: action.payload }
        case SET_USER_DETAILS:
            return { ...state, userDetails: action.payload }
        case SET_MENU_ITEMS:
            return { ...state, menuItems: action.payload }
        case SET_SELLERCREATION:
            return { ...state, sellerCreation: action.payload }
        case SET_ACCOUNTTYPE:
            return { ...state, accountType: action.payload }
        case SET_BUYNOWPRODUCTS:
            return { ...state, buyNow: action.payload }
        case SET_ACCOUNT_DETAILS:
            return { ...state, accountDetails: action.payload }
        case SET_REGION:
            return { ...state, region: action.payload }
        case SET_FlAWFILTER:
            return { ...state, flawFilter: action.payload }
        case SET_OCCUPATIONFILTER:
            return { ...state, occupationFilter: action.payload }
        case SET_ZODIACFILTER:
            return { ...state, zodiacSignFilter: action.payload }
        case SET_STATUSFILTER:
            return { ...state, statusFilter: action.payload }
        case SET_COUNT_API:
            return { ...state, countApi: action.payload }
        case SET_EDUCATIONLIST:
            return { ...state, educationList: action.payload }
        case SET_FULL_EDUCATIONLIST:
            return { ...state, fullEducations: action.payload }
        case SET_ZODIACSIGNS:
            return { ...state, zodiacSigns: action.payload }
        case SET_FLAWS:
            return { ...state, flaws: action.payload }
        case SET_STATUS:
            return { ...state, status: action.payload }
        case SET_OCCUPATION:
            return { ...state, occupation: action.payload }
        case SET_ALLSTARS:
            return { ...state, allStars: action.payload }
        case SET_FULL_OCCUPATIONS:
            return { ...state, fullOccupations: action.payload }
        case SET_TEDUCATIONS:
            return { ...state, tEducationList: action.payload }
        case SET_TFLAWS:
            return { ...state, tFlaws: action.payload }
        case SET_TSTATUS:
            return { ...state, tStatus: action.payload }
        case SET_TOCCUPATION:
            return { ...state, tOccupation: action.payload }
        case SET_DHISA:
            return { ...state, dhisa: action.payload }
        case SET_INITIAL_LOADING_FILTER:
            return { ...state, initialLoadingFilter: action.payload }
        case SET_SEARCH_VALUE:
            return { ...state, searchValue: action.payload }
        case SET_MIN_AGE:
            return {...state,minAge : action.payload}
        case SET_MAX_AGE:
            return {...state,maxAge : action.payload}
        case SET_SEARCH_COUNT:
            return {...state,searchCount : action.payload}
        case SET_TDHISA:
            return {...state,tDhisa : action.payload}
        case SET_FETCH_USER_DETAILS:
            return {...state,fetchUserDetails : action.payload}
        default:
            return state
    }
}

export default authReducers